<template>
    <div v-if="competence" class="competence-preview">
        <div class="preview-header">
            <div class="preview-name text-truncate">{{ competence.versus }}</div>
            <div class="preview-date">{{ dateLabel }}</div>
        </div>

        <div class="cp-info">
            <div class="cp-info-row">
                <v-icon size="18" color="accent">mdi-soccer-field</v-icon>
                <span>{{ $t('common.competence') }}</span>
            </div>
            <div v-if="competence.minutes" class="cp-info-row">
                <v-icon size="18" color="txtMuted">mdi-clock-outline</v-icon>
                <span>{{ competence.minutes }} {{ $tc('common.minutes', 2).toLowerCase() }}</span>
            </div>
        </div>

        <div class="preview-cta">
            <v-btn block large depressed color="primary" class="black--text start-btn" @click="$emit('start', competence)">
                {{ startLabel }}
                <v-icon right size="20">mdi-arrow-right</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: "CompetencePreview",
    props: {
        competence: {
            type: Object,
            default: null,
        },
    },
    computed: {
        dateLabel(vm = this) {
            const date = vm.competence?.rawDate?.full
            if (!date) return ''
            const label = vm.$moment(date).format(vm.$t('common.date_format_day_month'))
            return label.charAt(0).toUpperCase() + label.slice(1)
        },
        startLabel(vm = this) {
            const pre = !!vm.competence?.advance?.pre
            const post = !!vm.competence?.advance?.post
            if (pre && post) return vm.$t('common.see_again')
            if (pre) return vm.$t('common.continue')
            return vm.$t('routines.start_session')
        },
    },
}
</script>

<style scoped>
.competence-preview {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.preview-header {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.preview-name {
    font-size: 18px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
}

.preview-date {
    font-size: 13px;
    font-weight: 500;
    color: var(--v-txtSecondary-base);
}

.cp-info {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
    padding: 14px 16px;
}

.cp-info-row {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

.preview-cta .start-btn {
    border-radius: 12px;
    font-weight: 700;
    text-transform: none;
    letter-spacing: 0;
}
</style>
